import Image from 'next/image';
import { Collapsible, Link, Text } from '@invisionag/components';
import { useTranslation } from '@invisionag/next/i18n';
import googlePlayLogo from './img/google-play.png';
import appStoreLogo from './img/app-store.png';

export function DownloadLinks() {
  const { t } = useTranslation();
  const keyPrefix = 'login.setup-2fa-form.verification.step-1.download-links';

  return (
    <Collapsible label={t(`${keyPrefix}.label`)}>
      <div className="flex flex-col gap-4">
        <AuthenticatorDownload
          name={'Authy'}
          googlePlayUrl={t(`${keyPrefix}.authy.google-play-url`)}
          appStoreUrl={t(`${keyPrefix}.authy.apple-store-url`)}
        />
        <AuthenticatorDownload
          name={'Google Authenticator'}
          googlePlayUrl={t(`${keyPrefix}.google-authenticator.google-play-url`)}
          appStoreUrl={t(`${keyPrefix}.google-authenticator.apple-store-url`)}
        />
        <AuthenticatorDownload
          name={'Microsoft Authenticator'}
          googlePlayUrl={t(
            `${keyPrefix}.microsoft-authenticator.google-play-url`,
          )}
          appStoreUrl={t(
            `${keyPrefix}.microsoft-authenticator.apple-store-url`,
          )}
        />
      </div>
    </Collapsible>
  );
}

function AuthenticatorDownload({
  name,
  googlePlayUrl,
  appStoreUrl,
}: {
  name: string;
  googlePlayUrl: string;
  appStoreUrl: string;
}) {
  return (
    <div className="flex flex-col">
      <Text>{name}</Text>
      <div className="flex gap-4">
        <Link href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
          <Image
            src={googlePlayLogo}
            alt="Google Play"
            width={16}
            height={16}
          />
          Google Play
        </Link>
        <Link href={appStoreUrl} target="_blank" rel="noopener noreferrer">
          <Image src={appStoreLogo} alt="App Store" width={16} height={16} />
          App Store
        </Link>
      </div>
    </div>
  );
}
